import Button from "./Button";
import CountUp from "react-countup";
import { ChevronDown, ChevronUp, User, Book, Film } from "react-feather";

function TermSection({
  position,
  history,
  onClick,
  showValue,
  goToNextSection,
  category,
}) {
  const curTerm = history[history.length + position - 4];
  const prevTerm = history[history.length + position - 5];
  return (
    <div
      className="flex flex-col items-center justify-center w-full p-10 text-center h-screen/2 lg:h-screen"
      style={{
        background: `linear-gradient(
          rgba(0, 0, 0, 0.6), 
          rgba(0, 0, 0, 0.6)
        ), url(${curTerm.image}) no-repeat center/cover`,
      }}
    >
      <div className="relative w-full h-2/5">
        <span className="absolute bottom-0 right-0 flex flex-col items-center w-full font-serif text-3xl">
          <div>{typeToIcon[curTerm.category]}</div>
          <h1>"{curTerm.name}"</h1>
        </span>
      </div>
      <p>
        {position > 1
          ? "has"
          : category === "characters"
          ? "is favourited by"
          : "is on the list of"}
      </p>

      <div className="flex flex-col items-center">
        {((position > 1 && showValue) || position === 1) && (
          <h1
            className="text-4xl font-semibold text-yellow-200"
            style={{ color: curTerm.color }}
          >
            <CountUp
              start={position > 1 && !goToNextSection ? 0 : curTerm.value}
              end={curTerm.value}
              duration={1.5}
              separator=","
            />
          </h1>
        )}
        {position > 1 && !showValue && (
          <div className="flex flex-col justify-center h-24">
            {!goToNextSection && (
              <>
                <Button
                  onClick={() => onClick("higher")}
                  className="bg-transparent border-2 border-white hover:bg-white hover:text-black"
                  text="Takai"
                  icon={<ChevronUp />}
                />
                <Button
                  onClick={() => onClick("lower")}
                  className="bg-transparent border-2 border-white hover:bg-white hover:text-black"
                  text="Hikui"
                  icon={<ChevronDown />}
                />
              </>
            )}
          </div>
        )}
      </div>
      <p className="flex-grow">
        {position > 1 ? `users than ${prevTerm.name}` : "AniList users"}
      </p>
    </div>
  );
}

export default TermSection;

//{position > 1 && !showValue ? ( )}
const typeToIcon = {
  ANIME: <Film />,
  MANGA: <Book />,
  CHARACTER: <User />,
};
